<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form inline :model="formFilter" class="demo-form-inline">
                <el-form-item label="项目名称">
                    <el-input v-model="formFilter.project" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="formFilter.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="服务状态">
                    <el-select v-model="formFilter.status" placeholder="请选择服务状态">
                        <el-option label="全选" value=""></el-option>
                        <el-option :label="item" :value="key" v-for="(item, key) in ServiceStatus" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="default" v-if="isExportShow" @click="onExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="no"
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="project"
                        align="center"
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="姓名">
                        <template slot-scope="scope">
                            <el-button type="text" @click.stop="goPage(`/index/member/personal?id=${scope.row.member_id}`)" size="medium">{{scope.row.name}}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        label="服务总额">
                    </el-table-column>
                    <el-table-column
                        prop="complete_time"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="预计完成时间">
                    </el-table-column>
                    <el-table-column
                        label="服务状态"
                        :show-overflow-tooltip="true"
                        align="center">
                        <template slot-scope="scope">
                            {{ServiceStatus[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click.stop="toDetail(scope.row.id, scope.row.sub_id)" size="medium">详情
                            </el-button>
                            <el-button type="text" v-if="scope.row.status === 0"
                                       @click.stop="changeServiceStatus(scope.row.id, scope.row.sub_id, 1)" size="medium">确认
                            </el-button>
                            <el-button type="text" v-if="scope.row.status === 1"
                                       @click.stop="messageNotify(scope.row.id, scope.row.sub_id, 6)" size="medium">短信提醒
                            </el-button>
                            <el-button type="text" v-if="scope.row.status === 2"
                                       @click.stop="goPage(`/index/project/queryresult?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)"
                                       size="medium">确认成果
                            </el-button>
                            <el-button type="text"
                                       v-if="scope.row.status === 5 || scope.row.status === 7"
                                       @click.stop="goPage(`/index/project/queryresult?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)"
                                       size="medium">确认成果
                            </el-button>
                            <el-button type="text" v-if="scope.row.status === 8"
                                       @click.stop="messageNotify(scope.row.id, scope.row.sub_id, 8)" size="medium">短信提醒
                            </el-button>
                            <el-button type="text" v-if="scope.row.status === 9"
                                       @click.stop="goPage(`/index/project/querysettle?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)"
                                       size="medium">确认结算
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="10"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import { mapState } from 'vuex'
import { ServiceStatus } from '@/utils/STATUSLIST'

export default {
    name: 'ServiceList',
    inject: ['goPage'],
    data () {
        return {
            formFilter: {
                project: '',
                name: '',
                status: ''
            },
            form: {},
            ServiceStatus,
            lists: [],
            total_page: 1,
            statusList: ['待支付', '待匹配', '服务待确认', '服务进行中', '成果待确认', '服务待结算', '已完成', '已关闭']
        }
    },
    computed: {
        isExportShow () {
            return (this.lists.length !== 0)
        },
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.form = Object.assign({}, this.formFilter)
        this.getList()
    },
    methods: {
        getList (page = this.currentPage) {
            this.$http.get('/api/user/project/subitemslists', {
                params: {
                    page,
                    size: 10,
                    name: this.formFilter.name,
                    project: this.formFilter.project,
                    status: this.formFilter.status
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        onExport () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downloadsubitems?name=${this.form.name}&status=${this.form.status}&project=${this.form.project}`, '服务列表.xls')
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        onFilter () {
            this.formFilter.start_time = this.getDateFromRange(this.formFilter.daterange)[0]
            this.formFilter.end_time = this.getDateFromRange(this.formFilter.daterange)[1]
            this.form = Object.assign({}, this.formFilter)
            this.$store.commit('changeCondition', this.formFilter)
            this.getList(1)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        },
        toDetail (id, e) {
            this.$router.push(`/index/project/serviceinfo?id=${id}&sub_id=${e}`)
        },
        changeServiceStatus (id, sub_id, handle) {
            this.$confirm(`此操作将${handle * 1 === 1 ? '确认' : '拒绝'}服务用户, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/project/subconfirm', {
                    params: {
                        id,
                        sub_id,
                        status: handle
                    }
                })
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `${handle * 1 === 1 ? '确认' : '拒绝'}服务用户操作成功。`
                            })
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        messageNotify (id, sub_id, sign) {
            this.$confirm(`此操作将短信提醒用户操作, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/user/project/subsendsms', qs.stringify({
                    id,
                    sub_id,
                    type: sign
                }))
                    .then((res) => {
                        if (res.code === 0 && res.data && res.data.send_status === 1) {
                            this.$notify.success({
                                title: '通知',
                                message: `短信提醒操作成功。`
                            })
                        } else if (res.code === 0) {
                            this.$message.error((res.data && res.data.msg) || '发送短信失败')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
